export const Acoustics = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //width="73.958"
      // height="66.377"
      width={w}
      viewBox="0 0 73.958 66.377"
      fill={color}
    >
      <g
        id="Group_59"
        data-name="Group 59"
        transform="translate(-1.698 -4.442)"
      >
        <g
          id="Group_53"
          data-name="Group 53"
          transform="translate(34.316 11.704)"
        >
          <g id="Group_51" data-name="Group 51">
            <path
              id="Path_100"
              data-name="Path 100"
              d="M41.135 50.153a1.373 1.373 0 0 1-1.288-1.053l-4.8-34.415c-.234-1.873-1.17-2.927-1.637-2.927-.587 0-1.405 1.054-1.639 2.927L29.43 32.009a6.21 6.21 0 0 1-6.2 5.267 1.288 1.288 0 0 1 0-2.575 3.875 3.875 0 0 0 3.747-3.276L29.312 14.1c.469-3.044 2.108-5.151 4.214-5.151s3.745 2.106 4.214 5.151l4.8 34.415a1.156 1.156 0 0 1-1.054 1.405c-.233.233-.233.233-.351.233z"
              transform="translate(-21.937 -8.948)"
            />
          </g>
          <g
            id="Group_52"
            data-name="Group 52"
            transform="translate(17.892 .118)"
          >
            <path
              id="Path_101"
              data-name="Path 101"
              d="M37.271 54.087c-2.106 0-3.745-2.106-4.214-5.149a1.242 1.242 0 0 1 2.459-.351c.234 1.873 1.17 2.927 1.639 2.927.585 0 1.4-1.054 1.637-2.927l4.683-34.65c.351-2.927 1.99-4.916 3.979-4.916 2.108 0 3.747 2.106 4.214 5.149l4.8 34.417a1.241 1.241 0 0 1-2.458.351l-4.8-34.417c-.234-1.873-1.172-2.927-1.639-2.927s-1.288.938-1.521 2.693l-4.683 34.65c-.233 3.163-1.988 5.15-4.096 5.15z"
              transform="translate(-33.039 -9.021)"
            />
          </g>
        </g>
        <g
          id="Group_57"
          data-name="Group 57"
          transform="translate(1.698 4.442)"
        >
          <g id="Group_54" data-name="Group 54">
            <path
              id="Path_102"
              data-name="Path 102"
              d="M24.79 70.819a1.068 1.068 0 0 1-.82-.351l-9.546-14.984h-2.893c-6.79 0-9.833-9.248-9.833-17.793S4.741 19.9 11.531 19.9h2.893l9.545-15.1a1.247 1.247 0 0 1 1.405-.235 1.288 1.288 0 0 1 .7 1.172v25.281a6.726 6.726 0 0 1 5.97 6.674 6.8 6.8 0 0 1-5.97 6.672v25.285a1.552 1.552 0 0 1-.7 1.17zM11.531 22.473c-4.683 0-7.259 7.844-7.259 15.219s2.575 15.217 7.259 15.217h3.362a1.064 1.064 0 0 1 .819.351L23.5 66.722V43.076a1.3 1.3 0 0 1 1.288-1.288h.585a4.1 4.1 0 0 0 0-8.2h-.583a1.3 1.3 0 0 1-1.29-1.282V8.66l-7.789 13.462a1.257 1.257 0 0 1-.819.351z"
              transform="translate(-1.698 -4.442)"
            />
          </g>
          <g
            id="Group_55"
            data-name="Group 55"
            transform="translate(11.907 15.456)"
          >
            <path
              id="Path_103"
              d="M10.374 24.919a1.3 1.3 0 0 1-1.288-1.288V15.32a1.288 1.288 0 1 1 2.575 0v8.311a1.3 1.3 0 0 1-1.287 1.288z"
              transform="translate(-9.086 -14.032)"
            />
          </g>
          <g
            id="Group_56"
            data-name="Group 56"
            transform="translate(11.907 40.156)"
          >
            <path
              id="Path_104"
              data-name="Path 104"
              d="M10.374 40.245a1.3 1.3 0 0 1-1.288-1.288v-8.311a1.288 1.288 0 1 1 2.575 0v8.311a1.3 1.3 0 0 1-1.287 1.288z"
              transform="translate(-9.086 -29.358)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
export const Biologgers = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //width="94.518"
      // height="53.658"
      width={w}
      viewBox="0 0 94.518 53.658"
      fill={color}
    >
      <g
        id="Group_296"
        data-name="Group 296"
        transform="translate(-131.869 -369.287)"
      >
        <circle
          id="Ellipse_198"
          data-name="Ellipse 198"
          cx="2.025"
          cy="2.025"
          r="2.025"
          transform="translate(156.981 412.01)"
        />
        <circle
          id="Ellipse_199"
          data-name="Ellipse 199"
          cx="2.025"
          cy="2.025"
          r="2.025"
          transform="translate(163.381 412.415)"
        />
        <circle
          id="Ellipse_200"
          data-name="Ellipse 200"
          cx="2.025"
          cy="2.025"
          r="2.025"
          transform="translate(169.861 412.577)"
        />
        <circle
          id="Ellipse_201"
          data-name="Ellipse 201"
          cx="2.025"
          cy="2.025"
          r="2.025"
          transform="translate(176.261 412.415)"
        />
        <path
          id="Path_204"
          data-name="Path 204"
          d="M219.394 385.5h-1.519v-10.048a3.328 3.328 0 1 0-3.43 0V385.5h-1.52a7 7 0 0 0-6.509 4.455c-5.826-5.87-21.324-8.967-36.069-8.967-18.632 0-38.478 4.941-38.478 14.176v13.529c0 8.263 15.877 13.123 32.646 14.015l3.808.242h4.05l3.807-.161c12.861-.687 25.281-3.734 30.3-8.877a7 7 0 0 0 6.441 4.273h6.469a7 7 0 0 0 6.992-6.992v-18.7a7 7 0 0 0-6.988-6.993zm-68.165 32.265c-9.883-2.106-16.04-5.671-16.04-8.991v-7.453c3.645 3.078 10.046 5.266 17.5 6.643a8.019 8.019 0 0 0-1.458 9.8zm-7.777-15.8c6.724-2.592 16.445-4.131 26.895-4.131s20.17 1.539 26.894 4.131c-6.238 2.35-15.634 4.05-26.894 4.05-11.259.085-20.657-1.62-26.894-4.05zm62.052 6.8c0 5.185-14.419 10.855-35.157 10.855a96.833 96.833 0 0 1-12.313-.73 5.139 5.139 0 0 1-4.536-5.022 4.765 4.765 0 0 1 1.7-3.727 5.052 5.052 0 0 1 3.969-1.3 102.359 102.359 0 0 0 11.18.567c14.013 0 28.758-2.836 35.157-8.182zm-4.213-8.668c-7.129-3.483-18.55-5.589-30.944-5.589s-23.817 2.106-30.945 5.589c-2.673-1.539-4.213-3.241-4.213-4.942 0-5.1 14.419-10.854 35.158-10.854s35.153 5.755 35.153 10.859c0 1.701-1.535 3.403-4.208 4.94zm21.665 11.086a3.567 3.567 0 0 1-3.562 3.562h-6.469a3.567 3.567 0 0 1-3.562-3.562v-18.7a3.567 3.567 0 0 1 3.562-3.562h6.469a3.567 3.567 0 0 1 3.562 3.562z"
        />
        <path
          id="Path_205"
          data-name="Path 205"
          d="M203.131 389.947a1.714 1.714 0 0 0-1.715 1.715v14.6a1.715 1.715 0 0 0 3.43 0v-14.6a1.714 1.714 0 0 0-1.715-1.715z"
          transform="translate(9.979 2.965)"
        />
        <path
          id="Path_206"
          data-name="Path 206"
          d="M208.29 389.947a1.714 1.714 0 0 0-1.715 1.715v14.6a1.715 1.715 0 0 0 3.43 0v-14.6a1.715 1.715 0 0 0-1.715-1.715z"
          transform="translate(10.72 2.965)"
        />
      </g>
    </svg>
  )
}

export const Camera = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="61.321"
      // height="76.913"
      width={w}
      viewBox="0 0 61.321 76.913"
      fill={color}
    >
      <g
        id="Group_295"
        data-name="Group 295"
        transform="translate(-123.27 -266.597)"
      >
        <path
          id="Path_193"
          data-name="Path 193"
          d="M153.93 293.369a14.3 14.3 0 1 0 14.3 14.3 14.318 14.318 0 0 0-14.3-14.3zm11.99 14.3a11.989 11.989 0 1 1-11.99-11.988 12 12 0 0 1 11.99 11.99z"
        />
        <path
          id="Path_194"
          data-name="Path 194"
          d="M153.93 297.143a10.528 10.528 0 1 0 10.529 10.528 10.54 10.54 0 0 0-10.529-10.528zm8.215 10.529a8.215 8.215 0 1 1-8.215-8.214 8.224 8.224 0 0 1 8.215 8.214z"
        />
        <path
          id="Path_195"
          data-name="Path 195"
          d="M153.93 311.98c-.125 0-.248-.005-.366-.015a1.125 1.125 0 0 0-.841.257 1.159 1.159 0 0 0 .636 2.048c.189.017.379.023.571.023a1.156 1.156 0 1 0 0-2.313z"
        />
        <path
          id="Path_196"
          data-name="Path 196"
          d="M149.621 307.67a4.279 4.279 0 0 1 1.265-3.045 1.157 1.157 0 1 0-1.637-1.636 6.614 6.614 0 0 0 .18 9.536 1.147 1.147 0 0 0 .787.309 1.156 1.156 0 0 0 .787-2 4.327 4.327 0 0 1-1.382-3.164z"
        />
        <path
          id="Path_197"
          data-name="Path 197"
          d="M178.071 266.6h-48.28a6.528 6.528 0 0 0-6.521 6.52v63.872a6.529 6.529 0 0 0 6.521 6.521h48.28a6.528 6.528 0 0 0 6.52-6.521v-63.875a6.528 6.528 0 0 0-6.52-6.517zm3.52 70.392a3.524 3.524 0 0 1-3.52 3.521h-48.28a3.525 3.525 0 0 1-3.521-3.521v-63.875a3.525 3.525 0 0 1 3.521-3.52h48.28a3.524 3.524 0 0 1 3.52 3.52z"
        />
        <path
          id="Path_198"
          data-name="Path 198"
          d="M173.756 271.611H134.1a3.74 3.74 0 0 0-3.736 3.737v10.535a3.741 3.741 0 0 0 3.736 3.737h39.651a3.742 3.742 0 0 0 3.737-3.737v-10.535a3.741 3.741 0 0 0-3.732-3.737zm.737 14.272a.738.738 0 0 1-.737.737H134.1a.737.737 0 0 1-.736-.737v-10.535a.737.737 0 0 1 .736-.737h39.651a.738.738 0 0 1 .737.737z"
        />
        <path
          id="Path_199"
          data-name="Path 199"
          d="M163.381 328.261a1.5 1.5 0 0 0 0-3H143.5a1.5 1.5 0 0 0 0 3h1.342v5.867H143.5a1.5 1.5 0 0 0 0 3h19.879a1.5 1.5 0 1 0 0-3h-1.339v-5.867zm-4.341 5.867h-11.2v-5.867h11.2z"
        />
        <path
          id="Path_200"
          data-name="Path 200"
          d="M139.326 276a4.544 4.544 0 1 0 4.545 4.545 4.55 4.55 0 0 0-4.545-4.545zm0 6.089a1.544 1.544 0 1 1 1.545-1.544 1.546 1.546 0 0 1-1.545 1.54z"
        />
        <path
          id="Path_201"
          data-name="Path 201"
          d="M148.987 276a4.544 4.544 0 1 0 4.545 4.545 4.55 4.55 0 0 0-4.545-4.545zm0 6.089a1.544 1.544 0 1 1 1.545-1.544 1.546 1.546 0 0 1-1.545 1.54z"
        />
        <path
          id="Path_202"
          data-name="Path 202"
          d="M158.648 276a4.544 4.544 0 1 0 4.544 4.545 4.55 4.55 0 0 0-4.544-4.545zm0 6.089a1.544 1.544 0 1 1 1.544-1.544 1.546 1.546 0 0 1-1.544 1.54z"
        />
        <path
          id="Path_203"
          data-name="Path 203"
          d="M168.309 276a4.544 4.544 0 1 0 4.545 4.545 4.55 4.55 0 0 0-4.545-4.545zm0 6.089a1.544 1.544 0 1 1 1.545-1.544 1.546 1.546 0 0 1-1.545 1.54z"
        />
      </g>
    </svg>
  )
}

export const DataMgmt = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="69.908"
      // height="72.103"
      width={w}
      viewBox="0 0 69.908 72.103"
      fill={color}
    >
      <g
        id="Group_186"
        data-name="Group 186"
        transform="translate(-302.843 -315.86)"
      >
        <path
          id="Path_135"
          data-name="Path 135"
          d="M328.929 335.234a3.092 3.092 0 0 0-.378-.018 9.529 9.529 0 0 0 0 19.057 1.79 1.79 0 0 0 .3-.015 9.518 9.518 0 0 0 .074-19.024zm6.708 9.5a7.109 7.109 0 0 1-6.984 7.095h-.092a7.091 7.091 0 1 1 .015-14.181c.031 0 .068 0 .173.009a7.046 7.046 0 0 1 6.888 7.082z"
          transform="translate(19.217 22.966)"
        />
        <path
          id="Path_136"
          data-name="Path 136"
          d="M372.1 337.683a1.224 1.224 0 0 0 .59-1.454l-1.025-3.175a1.221 1.221 0 0 0-1.323-.835l-1.412.19a10.04 10.04 0 0 0-.984-1.159l.422-1.367a1.212 1.212 0 0 0-.606-1.443l-2.965-1.526a1.218 1.218 0 0 0-1.526.343l-.871 1.143a10.191 10.191 0 0 0-1.515-.129l-.671-1.259a1.209 1.209 0 0 0-1.445-.588l-3.177 1.015a1.215 1.215 0 0 0-.84 1.327l.2 1.417a9.954 9.954 0 0 0-1.165.986l-1.371-.415a1.218 1.218 0 0 0-1.439.61l-1.515 2.954a1.209 1.209 0 0 0 .348 1.526l1.137.864a10.028 10.028 0 0 0-.129 1.524l-1.266.669a1.233 1.233 0 0 0-.328.258v-13.615c0-5.431-10.187-9.684-23.189-9.684-12.935 0-23.1 4.218-23.185 9.614v51.6c0 2.591 1.651 4.944 4.773 6.8 8.68 5.167 26.084 5.42 35.554.6l.446 2.479a1.217 1.217 0 0 0 1.2 1h5.921a1.215 1.215 0 0 0 1.2-1l.553-3.081a16.5 16.5 0 0 0 3.393-1.4l2.552 1.784a1.214 1.214 0 0 0 1.557-.133l4.2-4.194a1.215 1.215 0 0 0 .138-1.559l-1.789-2.56a16.056 16.056 0 0 0 1.4-3.4l3.061-.536a1.212 1.212 0 0 0 1.008-1.2v-5.919a1.221 1.221 0 0 0-1-1.2l-3.061-.553a16.655 16.655 0 0 0-1.415-3.4l1.793-2.56a1.216 1.216 0 0 0-.142-1.563l-4.2-4.18a1.22 1.22 0 0 0-1.552-.136l-2.552 1.775a16.382 16.382 0 0 0-3.4-1.395l-.553-3.085a1.217 1.217 0 0 0-1.2-1h-1.513v-6.288l.75 2.346a1.2 1.2 0 0 0 1.325.837l1.426-.19a9.455 9.455 0 0 0 .99 1.163l-.42 1.373a1.217 1.217 0 0 0 .608 1.443l2.956 1.515a1.217 1.217 0 0 0 1.522-.343l.872-1.139a9.546 9.546 0 0 0 1.52.127l.671 1.266a1.213 1.213 0 0 0 1.076.647 1.174 1.174 0 0 0 .374-.059l3.177-1.023a1.216 1.216 0 0 0 .833-1.327l-.2-1.412a9.571 9.571 0 0 0 1.165-.986l1.367.42a1.222 1.222 0 0 0 1.443-.612l1.515-2.963a1.216 1.216 0 0 0-.346-1.526l-1.133-.864a9.951 9.951 0 0 0 .12-1.515zm-12.011 21.167a1.223 1.223 0 0 0-.035 1.34 14.23 14.23 0 0 1 1.736 4.169 1.22 1.22 0 0 0 .966.914l2.823.509v3.872l-2.827.494a1.225 1.225 0 0 0-.979.925 13.609 13.609 0 0 1-1.721 4.161 1.227 1.227 0 0 0 .037 1.34l1.655 2.361-2.755 2.746-2.35-1.644A1.224 1.224 0 0 0 355.3 380a14.092 14.092 0 0 1-4.154 1.716 1.215 1.215 0 0 0-.92.971l-.514 2.842h-3.879l-.512-2.845a1.225 1.225 0 0 0-.883-.96l-.181-.046c-.042-.009-.083-.017-.136-.031l-.127-.039a13.953 13.953 0 0 1-3.745-1.608 1.215 1.215 0 0 0-1.334.039l-2.361 1.644-2.751-2.746 1.644-2.361a1.224 1.224 0 0 0 .039-1.336 12.578 12.578 0 0 1-.848-1.62.686.686 0 0 0-.068-.133 13.016 13.016 0 0 1-.8-2.4 1.212 1.212 0 0 0-.979-.931l-2.836-.494v-3.874l2.834-.512a1.22 1.22 0 0 0 .966-.912 14.516 14.516 0 0 1 1.5-3.8l.221-.361a1.208 1.208 0 0 0-.031-1.351l-1.644-2.359 2.751-2.742 2.361 1.64a1.229 1.229 0 0 0 1.332.037 13.784 13.784 0 0 1 4.148-1.7 1.217 1.217 0 0 0 .927-.973l.514-2.853h3.879l.512 2.853a1.217 1.217 0 0 0 .927.973 13.839 13.839 0 0 1 4.15 1.7 1.213 1.213 0 0 0 1.332-.039l2.355-1.638 2.755 2.74zm-16.473-10.388-.553 3.085a16.213 16.213 0 0 0-3.4 1.395l-2.565-1.778a1.217 1.217 0 0 0-1.555.138l-4.191 4.18a1.218 1.218 0 0 0-.138 1.561l1.321 1.9c-9.548 1.351-20.786-.614-25.31-4.482a4.7 4.7 0 0 1-1.95-3.5v-7.115c3.861 3.667 11.669 5.912 20.745 5.912s16.9-2.245 20.758-5.912v3.621h-1.968a1.215 1.215 0 0 0-1.194.995zm-11.466 12.99c-.225.551-.4 1.06-.553 1.557l-3.074.553a1.217 1.217 0 0 0-1 1.2v5.919a1.214 1.214 0 0 0 1.01 1.2l3.068.534c.059.2.122.407.188.608-8.208.975-20.174-.621-24.678-4.563a4.68 4.68 0 0 1-1.83-3.529v-9.017c5.96 5.748 19.179 6.486 26.869 5.538zm.656 13.958c.063.136.127.269.2.4l-1.786 2.565a1.22 1.22 0 0 0 .138 1.559l4.194 4.191a1.187 1.187 0 0 0 .555.317c-9.769 2.346-21.873.722-27.645-2.967-1.45-.927-3.181-2.444-3.181-4.4v-7.105c6.111 5.914 19.819 6.511 27.525 5.44zm7.845 7.565a28.241 28.241 0 0 1-3.358 1.161l2.377-1.657q.475.262.981.496zm6.131-53.013v8.905c0 4.5-9.7 8.446-20.752 8.446s-20.752-3.949-20.752-8.446v-8.907c3.828 3.221 11.807 5.267 20.754 5.267s16.921-2.046 20.75-5.264zm-20.749 2.829c-12.229 0-20.752-3.822-20.752-7.248s8.523-7.248 20.752-7.248 20.749 3.82 20.749 7.248-8.521 7.249-20.75 7.249zm38.315 14.334-1.233.4-.544-1.034a1.247 1.247 0 0 0-1.157-.645h-.014a7.253 7.253 0 0 1-2.346-.2 1.215 1.215 0 0 0-1.273.439l-.722.94-1.141-.584.348-1.13a1.21 1.21 0 0 0-.378-1.29 7.158 7.158 0 0 1-1.524-1.791 1.21 1.21 0 0 0-1.207-.582l-1.172.157-.391-1.224 1.036-.547a1.214 1.214 0 0 0 .645-1.168 7.4 7.4 0 0 1 .2-2.359 1.206 1.206 0 0 0-.442-1.277l-.936-.708.586-1.139 1.124.341a1.223 1.223 0 0 0 1.275-.374 7.755 7.755 0 0 1 1.821-1.539 1.223 1.223 0 0 0 .571-1.2l-.162-1.159 1.229-.391.549 1.03a1.206 1.206 0 0 0 1.168.643 7.412 7.412 0 0 1 2.361.2 1.226 1.226 0 0 0 1.257-.442l.719-.94 1.15.593-.345 1.122a1.213 1.213 0 0 0 .369 1.283 7.681 7.681 0 0 1 1.539 1.808 1.181 1.181 0 0 0 1.2.571l1.152-.153.4 1.233-1.039.547a1.222 1.222 0 0 0-.645 1.168 7.475 7.475 0 0 1-.19 2.359 1.221 1.221 0 0 0 .444 1.262l.929.708-.586 1.15-1.115-.346a1.209 1.209 0 0 0-1.292.376 7.209 7.209 0 0 1-1.8 1.526 1.216 1.216 0 0 0-.582 1.211z"
        />
        <path
          id="Path_137"
          data-name="Path 137"
          d="M337.523 331.8a5.693 5.693 0 1 0-5.073 3.1 5.634 5.634 0 0 0 5.073-3.1zm-2.169-1.113a3.254 3.254 0 1 1-5.521-3.406 3.254 3.254 0 0 1 5.521 3.406z"
          transform="translate(28.373 9.081)"
        />
      </g>
    </svg>
  )
}
export const Drones = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="80.719"
      // height="74.081"
      width={w}
      viewBox="0 0 80.719 74.081"
      fill={color}
    >
      <g
        id="Group_190"
        data-name="Group 190"
        transform="translate(-292.472 -460.682)"
      >
        <g
          id="Group_188"
          data-name="Group 188"
          transform="translate(325.567 514.731)"
        >
          <path
            id="Path_142"
            data-name="Path 142"
            d="M310.051 496.7a7.308 7.308 0 1 0 7.307-7.307 7.313 7.313 0 0 0-7.307 7.307zm12.094 0a4.788 4.788 0 1 1-4.788-4.788 4.784 4.784 0 0 1 4.788 4.788z"
            transform="translate(-310.051 -489.391)"
          />
        </g>
        <g
          id="Group_189"
          data-name="Group 189"
          transform="translate(292.472 460.682)"
        >
          <path
            id="Path_143"
            data-name="Path 143"
            d="M367.27 481.344h-3.654a.862.862 0 0 1-.883-.881v-3.78a1.19 1.19 0 0 0-1.26-1.26h-1.386v-2.9a3.73 3.73 0 0 0 1.26.252c.126 0 11.844-.883 11.844-4.411s-11.844-4.409-11.844-4.409a4.483 4.483 0 0 0-1.26.252v-2.269a1.191 1.191 0 0 0-1.26-1.26h-3.654a1.191 1.191 0 0 0-1.26 1.26v2.269a3.721 3.721 0 0 0-1.26-.252c-.126 0-11.844.883-11.844 4.409s11.844 4.411 11.844 4.411a4.468 4.468 0 0 0 1.26-.252v2.9h-1.386a1.19 1.19 0 0 0-1.259 1.26v3.78a.862.862 0 0 1-.883.881h-35.022a.862.862 0 0 1-.883-.881v-3.78a1.191 1.191 0 0 0-1.259-1.26h-1.386v-2.9a3.72 3.72 0 0 0 1.26.252c.126 0 11.842-.883 11.842-4.411s-11.842-4.409-11.842-4.409a4.471 4.471 0 0 0-1.26.252v-2.269a1.191 1.191 0 0 0-1.259-1.26h-3.654a1.19 1.19 0 0 0-1.26 1.26v2.269a3.731 3.731 0 0 0-1.26-.252s-11.844.883-11.844 4.409 11.844 4.411 11.844 4.411a4.481 4.481 0 0 0 1.26-.252v2.9h-1.386a1.191 1.191 0 0 0-1.261 1.26v3.78a.86.86 0 0 1-.881.881h-3.654a6.023 6.023 0 0 0-5.921 7.056 6.5 6.5 0 0 0 6.173 4.788h15.007l1.246 7.054a4.863 4.863 0 0 0 4.788 3.906h6.8v5.164h-7.937a3.98 3.98 0 0 0-4.031 4.033v17.386a3.98 3.98 0 0 0 4.031 4.031h28.474a3.98 3.98 0 0 0 4.033-4.031v-17.386a3.981 3.981 0 0 0-4.033-4.033h-7.937v-5.164h6.8a4.969 4.969 0 0 0 4.788-3.906l1.32-7.054h15.189a5.922 5.922 0 0 0 0-11.844zm-5.923-14.865a37.147 37.147 0 0 1 8.82 1.888 37.068 37.068 0 0 1-8.82 1.89c-.629 0-1.26-.755-1.26-1.89s.631-1.888 1.26-1.888zm-8.692 3.652a37.07 37.07 0 0 1-8.82-1.89 37.152 37.152 0 0 1 8.82-1.888c.629 0 1.26.755 1.26 1.888s-.631 1.89-1.26 1.89zm3.779-6.928h1.135v12.22h-1.135zm-43.339 3.276a37.115 37.115 0 0 1 8.818 1.888 37.036 37.036 0 0 1-8.818 1.89c-.631 0-1.26-.755-1.26-1.89s.629-1.888 1.26-1.888zm-8.692 3.652a37.05 37.05 0 0 1-8.82-1.89 37.132 37.132 0 0 1 8.82-1.888c.629 0 1.26.755 1.26 1.888s-.632 1.89-1.263 1.89zm3.779-6.928h1.133v12.22h-1.133zm40.441 50.143v17.386a1.455 1.455 0 0 1-1.512 1.512h-28.474a1.456 1.456 0 0 1-1.512-1.512v-17.387a1.455 1.455 0 0 1 1.512-1.512h28.473a1.531 1.531 0 0 1 1.512 1.512zm-11.968-4.033H329.1v-5.164h7.559zm30.616-18.646h-16.254a1.356 1.356 0 0 0-1.26 1.009l-1.512 8.062a2.293 2.293 0 0 1-2.269 1.89H319.9a2.291 2.291 0 0 1-2.269-1.89l-1.512-8.062a1.358 1.358 0 0 0-1.26-1.009h-16.127a3.814 3.814 0 0 1-3.654-2.771 3.475 3.475 0 0 1 3.4-4.157h3.654a3.388 3.388 0 0 0 3.4-3.4v-2.521h6.425v2.521a3.388 3.388 0 0 0 3.4 3.4h35.023a3.387 3.387 0 0 0 3.4-3.4v-2.521h6.426v2.521a3.387 3.387 0 0 0 3.4 3.4h3.654a3.465 3.465 0 0 1 0 6.928z"
            transform="translate(-292.472 -460.682)"
          />
        </g>
      </g>
    </svg>
  )
}
export const EDna = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="83.195"
      // height="56.946"
      width={w}
      viewBox="0 0 83.195 56.946"
      fill={color}
    >
      <g data-name="Group 193">
        <path
          data-name="Path 157"
          d="M349.013 623.67c0 4.978-1.924 8.405-5.654 11.471l-2.479-3.012a13.738 13.738 0 0 0 2.192-2.217h-13.527c4.646 5.736 15.235 8.063 18.422 18.677 1.35 4.493.812 9.906-4.64 15.626l-2.83-2.691c3.992-4.188 4.646-8.025 3.886-11.213h-8.17v-3.826h6.62c-5.46-9.423-19.424-9.417-19.424-22.814h3.916a10.156 10.156 0 0 0 .28 2.417h17.252a11.451 11.451 0 0 0 .243-2.417zm6.266 4.816a3.278 3.278 0 1 1-3.279 3.278 3.278 3.278 0 0 1 3.279-3.278zm7.693 10.035a4.215 4.215 0 1 1-4.215 4.215 4.213 4.213 0 0 1 4.216-4.215zm11.691 16.1a3.144 3.144 0 1 1-3.143 3.145 3.146 3.146 0 0 1 3.144-3.141zm-12.712.685a3.563 3.563 0 1 1-3.562 3.564 3.564 3.564 0 0 1 3.563-3.559zm-8.295-4.965a2.476 2.476 0 1 1-2.477 2.474 2.475 2.475 0 0 1 2.479-2.47zm4.031 20.5a2.475 2.475 0 1 1-2.474 2.477 2.476 2.476 0 0 1 2.475-2.469zm-40.547-42.362a3.278 3.278 0 1 0 3.278 3.278 3.278 3.278 0 0 0-3.276-3.271zm-7.693 10.035a4.215 4.215 0 1 0 4.215 4.215 4.214 4.214 0 0 0-4.213-4.208zm-11.691 16.1a3.144 3.144 0 1 0 3.143 3.145 3.144 3.144 0 0 0-3.142-3.134zm12.712.685a3.563 3.563 0 1 0 3.562 3.564 3.564 3.564 0 0 0-3.561-3.552zm8.295-4.965a2.476 2.476 0 1 0 2.477 2.474 2.475 2.475 0 0 0-2.476-2.463zm-4.031 20.5a2.475 2.475 0 1 0 2.474 2.477 2.476 2.476 0 0 0-2.473-2.462zm13.1-16.869h8.38v3.835h-7.295c4.472 9.252 20.162 9.751 20.162 22.812h-3.916a9.407 9.407 0 0 0-.3-2.415h-17.441a15.29 15.29 0 0 0-.164 2.415h-3.916c0-5.423 1.656-8.446 6.233-11.266l2.049 3.319a12.839 12.839 0 0 0-2.274 1.708h13.42c-5.4-6.149-18.137-8.06-18.9-20.9-.335-5.626 2.894-10.18 5.562-13.029l2.845 2.677c-2.151 2.3-4.759 5.91-4.507 10.123.01.256.03.496.061.735z"
          transform="translate(-294.614 -623.67)"
        />
      </g>
    </svg>
  )
}
export const GIS = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="83.195"
      // height="72.103"
      width={w}
      viewBox="0 0 83.195 72.103"
      fill={color}
    >
      <g
        id="Group_60"
        data-name="Group 60"
        transform="translate(-1.333 -4.348)"
      >
        <path
          id="Path_109"
          data-name="Path 109"
          d="M71.937 45.4a1.384 1.384 0 0 0-1.274-.841H51.154c4.627-7.365 9.8-16.8 9.8-22.185a18.026 18.026 0 1 0-36.051 0c0 5.384 5.175 14.821 9.8 22.185H15.2a1.384 1.384 0 0 0-1.274.841L1.446 74.518a1.387 1.387 0 0 0 1.274 1.933h80.422a1.387 1.387 0 0 0 1.387-1.387 1.366 1.366 0 0 0-.112-.546zm-11.368 1.932h9.18l1.469 3.435-1.838.614-2.262-1.131a1.376 1.376 0 0 0-.957-.1l-4.784 1.2-1.611-1.615zM27.678 22.374a15.252 15.252 0 1 1 30.5 0c0 6.635-10.138 22.3-15.252 29.518-5.11-7.213-15.248-22.883-15.248-29.518zm18.67 29.466c3.077.637 4.9 2.025 4.9 3.118 0 1.449-3.166 3.467-8.32 3.467s-8.32-2.018-8.32-3.467c0-1.092 1.826-2.481 4.9-3.118a151.039 151.039 0 0 0 2.3 3.244 1.386 1.386 0 0 0 1.938.3 1.4 1.4 0 0 0 .3-.3c.154-.203 1.026-1.401 2.302-3.244zm-30.235-4.508h8.974l-1.039 1.558-4.69 1.172-3.99-1zM43 70.465l-1.071 3.212H4.824l9.44-22.03 4.758 1.19a1.392 1.392 0 0 0 .675 0l5.546-1.387a1.384 1.384 0 0 0 .816-.576l2.363-3.542h8.064q.707 1.084 1.362 2.058c-3.7 1.023-6.009 3.089-6.009 5.568 0 3.557 4.768 6.241 11.093 6.241s11.093-2.684 11.093-6.241c0-2.479-2.306-4.545-6.009-5.568.434-.648.89-1.335 1.362-2.058h8.27l-.778 2.334a1.386 1.386 0 0 0 .335 1.419l2.773 2.773a1.388 1.388 0 0 0 1.317.366l5.048-1.263 2.315 1.158a1.364 1.364 0 0 0 1.058.073l2.6-.866 2.046 4.774-6.239-1.04a1.422 1.422 0 0 0-.849.125l-8.18 4.094-5.4 1.349a1.392 1.392 0 0 0-.9.726L50.32 68.29l-6.267 1.255a1.391 1.391 0 0 0-1.053.92zm1.852 3.212.523-1.57 6.15-1.231a1.379 1.379 0 0 0 .971-.739l2.488-4.975 4.929-1.231a1.575 1.575 0 0 0 .277-.105l7.916-3.958 7.554 1.258 5.377 12.552z"
        />
        <path
          id="Path_110"
          data-name="Path 110"
          d="M40.612 19.326A11.093 11.093 0 1 0 29.52 30.418a11.093 11.093 0 0 0 11.092-11.092zm-19.412 0a8.32 8.32 0 1 1 8.32 8.32 8.319 8.319 0 0 1-8.32-8.32z"
          transform="translate(13.411 3.048)"
        />
        <path
          id="Path_111"
          data-name="Path 111"
          d="M30.982 40.8a1.42 1.42 0 0 0-.471-.535l-3.93-2.618-2.62-3.93A1.384 1.384 0 0 0 22.8 33.1h-4.16a1.381 1.381 0 0 0-.98.407l-2.22 2.218-4.783-1.2a1.388 1.388 0 0 0-1.683 1.008l-1.383 5.548a1.382 1.382 0 0 0 .191 1.108l2.773 4.16a1.394 1.394 0 0 0 .817.576l5.546 1.387a1.34 1.34 0 0 0 .337.037h4.16a1.379 1.379 0 0 0 .619-.139l2.261-1.13 3.614 1.2a1.365 1.365 0 0 0 .439.066 1.381 1.381 0 0 0 .98-.407l2.772-2.77a1.381 1.381 0 0 0 .261-1.6zm-3 4.576-3.348-1.11a1.376 1.376 0 0 0-1.056.073l-2.482 1.249h-3.671l-4.859-1.218-2.134-3.205.9-3.6 4.2 1.049a1.383 1.383 0 0 0 1.317-.364l2.368-2.375h2.843l2.357 3.542a1.378 1.378 0 0 0 .384.384l3.855 2.57.774 1.551z"
          transform="translate(4.876 22.555)"
        />
      </g>
    </svg>
  )
}
export const ML = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="64.958"
      // height="69.282"
      width={w}
      viewBox="0 0 64.958 69.282"
      fill={color}
    >
      <path
        data-name="Path 159"
        d="M364.918 272.879a5.5 5.5 0 0 0-1.407.216l-7.253-7.145v-1.08a10.4 10.4 0 0 0 7.145-10.176 11.36 11.36 0 0 0-1.948-6.386 11.111 11.111 0 0 0 1.948-6.386 10.354 10.354 0 0 0-8.118-10.392 10.018 10.018 0 0 0-9.741-9.525 9.811 9.811 0 0 0-8.768 5.954 9.568 9.568 0 0 0-8.552-5.954c-5.087 0-9.2 4.222-9.633 9.525a10.248 10.248 0 0 0-8.118 10.392 11.111 11.111 0 0 0 1.948 6.386 11.111 11.111 0 0 0-1.948 6.386 10.413 10.413 0 0 0 6.818 10.065v1.191l-7.251 7.25a4.314 4.314 0 1 0 2.6 5.519 3.778 3.778 0 0 0 .327-1.515 4.329 4.329 0 0 0-1.083-2.812l7.142-7.145a11.281 11.281 0 0 0 3.358 5.521l-1.842 1.84v6.062a4.358 4.358 0 1 0 2.166 8.442 4.315 4.315 0 0 0 3.139-5.3 4.575 4.575 0 0 0-3.139-3.139v-5.089l1.516-1.515a9.173 9.173 0 0 0 4.112.975 8.862 8.862 0 0 0 7.361-4.006v11.691a4.358 4.358 0 1 0 5.303 3.138 4.58 4.58 0 0 0-3.139-3.139v-11.907a9.653 9.653 0 0 0 7.685 4.222 9.941 9.941 0 0 0 3.028-.54l2.274 2.272v4.006a4.353 4.353 0 0 0-2.491 5.627 4.353 4.353 0 1 0 8.12-3.139 4.273 4.273 0 0 0-3.466-2.7v-4.659l-2.38-2.382a10.35 10.35 0 0 0 4.222-5.954l6.818 6.821a4.3 4.3 0 1 0 3.247-1.515zm-56.285 6.494a2.165 2.165 0 1 1 2.164-2.166 2.173 2.173 0 0 1-2.165 2.166zm15.154 5.411a2.165 2.165 0 1 1-2.166-2.164 2.173 2.173 0 0 1 2.166 2.164zm30.847 0a2.164 2.164 0 1 1-2.164-2.164 2.171 2.171 0 0 1 2.164 2.164zm-26.3-11.9a9.129 9.129 0 0 1-2.488-.435l2.272-2.272v-3.79h-2.164v2.813l-2.056 2.058a8.367 8.367 0 0 1-3.031-6.713c0-4.871 3.355-8.982 7.359-8.982v-2.166c-4.654 0-8.658 4.222-9.309 9.525a8.264 8.264 0 0 1-6.17-8.226 9.378 9.378 0 0 1 .651-3.463 5.469 5.469 0 0 0 4.979 3.247v-2.166a3.815 3.815 0 0 1 0-7.575v-2.169a5.331 5.331 0 0 0-4.871 3.139 8.642 8.642 0 0 1-.759-3.679 8.379 8.379 0 0 1 5.953-8.23c.435 5.519 4.438 9.849 9.417 9.849v-2.166c-4 0-7.359-4.112-7.359-8.874 0-4.654 3.355-8.444 7.575-8.444 4.114 0 7.361 3.9 7.361 8.66v10.932a4.987 4.987 0 0 0-3.247-1.191v2.166a3.525 3.525 0 0 1 3.247 3.787 3.525 3.525 0 0 1-3.247 3.787v2.166a4.987 4.987 0 0 0 3.247-1.191v10.932c-.002 4.66-3.357 8.666-7.363 8.666zm10.608 14.071a2.165 2.165 0 1 1-2.164-2.166 2.17 2.17 0 0 1 2.161 2.162zm10.173-15.055-2.6-2.49v-3.031h-2.164v3.9l2.488 2.49a5.261 5.261 0 0 1-1.3.108c-4.114 0-7.685-4.006-7.685-8.66v-10.93a4.987 4.987 0 0 0 3.247 1.191v-2.166c-1.842 0-3.247-1.624-3.247-3.787s1.4-3.787 3.247-3.787v-2.168a4.987 4.987 0 0 0-3.247 1.191v-10.932c0-4.654 3.571-8.66 7.685-8.66 4.22 0 7.575 3.79 7.575 8.444s-3.355 8.442-7.575 8.442v2.166c4.979 0 9.09-4.114 9.633-9.417a8.051 8.051 0 0 1 5.954 8.226 8.64 8.64 0 0 1-.759 3.679 5.721 5.721 0 0 0-4.87-3.139v2.166a3.878 3.878 0 0 1 0 7.685v2.164a5.469 5.469 0 0 0 4.979-3.247 9.388 9.388 0 0 1 .651 3.463 8.148 8.148 0 0 1-6.17 8.226c-.759-4.979-4.763-8.874-9.527-8.874v2.164c4.114 0 7.469 3.787 7.469 8.334a7.892 7.892 0 0 1-3.784 7.249zm15.8 7.469a2.165 2.165 0 1 1 2.164-2.166 2.171 2.171 0 0 1-2.161 2.17z"
        transform="translate(-304.29 -222.005)"
      />
    </svg>
  )
}
export const Mobile = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="46.864"
      // height="72.835"
      width={w}
      viewBox="0 0 46.864 72.835"
      fill={color}
    >
      <g
        id="Group_185"
        data-name="Group 185"
        transform="translate(-307.857 -266.189)"
      >
        <path
          id="Path_126"
          data-name="Path 126"
          d="M320.088 300.163a3.773 3.773 0 1 0-3.754-3.784 3.784 3.784 0 0 0 3.754 3.784zm0-4.631a.844.844 0 0 1 .861.847.851.851 0 1 1-1.7 0 .844.844 0 0 1 .839-.847z"
          transform="translate(11.191 34.889)"
        />
        <path
          id="Path_127"
          data-name="Path 127"
          d="M326.96 268.271h-10.42a1.457 1.457 0 0 0 0 2.914h10.42a1.457 1.457 0 1 0 0-2.914z"
          transform="translate(9.539 2.748)"
        />
        <path
          id="Path_128"
          data-name="Path 128"
          d="M315.124 339.024h32.331a7.283 7.283 0 0 0 7.267-7.283v-58.27a7.283 7.283 0 0 0-7.267-7.283h-32.331a7.283 7.283 0 0 0-7.267 7.283v58.27a7.283 7.283 0 0 0 7.267 7.283zm36.683-7.283a4.365 4.365 0 0 1-4.352 4.369h-32.331a4.365 4.365 0 0 1-4.353-4.369v-5.292h41.036zm-41.036-8.206v-44.771h41.036v44.771zm0-50.063a4.365 4.365 0 0 1 4.353-4.369h32.331a4.365 4.365 0 0 1 4.352 4.369v2.38h-41.036z"
        />
        <path
          id="Path_129"
          data-name="Path 129"
          d="M321.428 273.44h-7.267a1.456 1.456 0 0 0-1.461 1.46v6.642a1.456 1.456 0 0 0 1.461 1.458h7.267a1.456 1.456 0 0 0 1.457-1.457V274.9a1.457 1.457 0 0 0-1.457-1.46zm-1.457 6.642h-4.353v-3.728h4.353z"
          transform="translate(6.399 9.572)"
        />
        <path
          id="Path_130"
          data-name="Path 130"
          d="M327.545 273.44h-7.267a1.456 1.456 0 0 0-1.457 1.457v6.642a1.456 1.456 0 0 0 1.457 1.461h7.267a1.457 1.457 0 0 0 1.455-1.46v-6.64a1.457 1.457 0 0 0-1.455-1.46zm-1.457 6.642h-4.353v-3.728h4.353z"
          transform="translate(14.474 9.572)"
        />
        <path
          id="Path_131"
          data-name="Path 131"
          d="M321.428 279.2h-7.267a1.455 1.455 0 0 0-1.457 1.457v6.643a1.457 1.457 0 0 0 1.457 1.457h7.267a1.457 1.457 0 0 0 1.457-1.457v-6.643a1.455 1.455 0 0 0-1.457-1.457zm-1.457 6.642h-4.353v-3.731h4.353z"
          transform="translate(6.399 17.175)"
        />
        <path
          id="Path_132"
          data-name="Path 132"
          d="M327.545 279.2h-7.267a1.455 1.455 0 0 0-1.457 1.457v6.643a1.457 1.457 0 0 0 1.457 1.457h7.267A1.457 1.457 0 0 0 329 287.3v-6.643a1.455 1.455 0 0 0-1.455-1.457zm-1.457 6.642h-4.353v-3.731h4.353z"
          transform="translate(14.474 17.175)"
        />
        <path
          id="Path_133"
          data-name="Path 133"
          d="M321.428 284.956h-7.267a1.457 1.457 0 0 0-1.457 1.457v6.645a1.455 1.455 0 0 0 1.457 1.457h7.267a1.455 1.455 0 0 0 1.457-1.457v-6.645a1.457 1.457 0 0 0-1.457-1.457zm-1.457 6.647h-4.353v-3.733h4.353z"
          transform="translate(6.399 24.775)"
        />
        <path
          id="Path_134"
          data-name="Path 134"
          d="M327.545 284.956h-7.267a1.456 1.456 0 0 0-1.457 1.457v6.645a1.455 1.455 0 0 0 1.457 1.457h7.267a1.455 1.455 0 0 0 1.455-1.457v-6.645a1.457 1.457 0 0 0-1.455-1.457zm-1.457 6.647h-4.353v-3.733h4.353z"
          transform="translate(14.474 24.775)"
        />
      </g>
    </svg>
  )
}
export const PAMgmt = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="78.247"
      // height="78.247"
      width={w}
      viewBox="0 0 78.247 78.247"
      fill={color}
    >
      <g
        id="Group_297"
        data-name="Group 297"
        transform="translate(-146.495 -505.299)"
      >
        <circle
          id="Ellipse_202"
          data-name="Ellipse 202"
          cx="1.411"
          cy="1.411"
          r="1.411"
          transform="translate(215.837 511.382)"
        />
        <circle
          id="Ellipse_203"
          data-name="Ellipse 203"
          cx="1.411"
          cy="1.411"
          r="1.411"
          transform="translate(210.971 511.382)"
        />
        <circle
          id="Ellipse_204"
          data-name="Ellipse 204"
          cx="1.411"
          cy="1.411"
          r="1.411"
          transform="translate(206.105 511.382)"
        />
        <path
          id="Path_207"
          data-name="Path 207"
          d="M220.289 505.3h-69.342a4.457 4.457 0 0 0-4.452 4.453v69.342a4.458 4.458 0 0 0 4.452 4.453h69.342a4.458 4.458 0 0 0 4.453-4.453v-69.343a4.458 4.458 0 0 0-4.453-4.452zm-70.972 4.453a1.632 1.632 0 0 1 1.63-1.63h69.342a1.632 1.632 0 0 1 1.63 1.63v7.713h-72.6zm72.6 10.535v58.807a1.633 1.633 0 0 1-1.63 1.63h-69.34a1.632 1.632 0 0 1-1.63-1.63v-58.808z"
        />
        <path
          id="Path_208"
          data-name="Path 208"
          d="M170.009 547.873a3.641 3.641 0 0 0 .611-.052 3.417 3.417 0 0 0 1.769-.9l.825.346a1.483 1.483 0 0 0 .546.105 1.424 1.424 0 0 0 .549-2.716l-.824-.34a3.252 3.252 0 0 0-.056-.51 3.485 3.485 0 1 0-3.42 4.072zm-.7-3.348a.682.682 0 0 1 .107-.47.672.672 0 0 1 .389-.269h.156a.642.642 0 0 1 .371.117.661.661 0 0 1 .272.414.681.681 0 0 1-.106.468.666.666 0 0 1-.371.26h-.051a.679.679 0 0 1-.5-.108.662.662 0 0 1-.264-.412z"
          transform="translate(-4.431 -7.884)"
        />
        <path
          id="Path_209"
          data-name="Path 209"
          d="M167.619 553.81a11.748 11.748 0 0 0 8.627-19.726h.017l-.332-.332a11.677 11.677 0 0 0-8.308-3.444 11.751 11.751 0 0 0 0 23.5zm-6.693-11.757a1.413 1.413 0 0 0-1.412-1.412h-.7a8.822 8.822 0 0 1 1.584-3.815l.5.5a1.413 1.413 0 0 0 2.414-.994 1.421 1.421 0 0 0-.418-1l-.508-.5a8.805 8.805 0 0 1 3.827-1.578v.712a1.411 1.411 0 1 0 2.822 0v-.709a8.9 8.9 0 0 1 3.806 1.614l-.489.467a1.416 1.416 0 1 0 2.01 2l.491-.491a8.876 8.876 0 0 1 1.578 3.809h-.693a1.411 1.411 0 0 0 0 2.822h.694a8.534 8.534 0 0 1-.132.659l-.666-.277a1.411 1.411 0 0 0-1.071 2.607l.66.274c-.111.189-.23.374-.356.552l-.518-.5a1.412 1.412 0 0 0-2 2l.5.5a8.873 8.873 0 0 1-10.445 0l.476-.486a1.412 1.412 0 1 0-1.781-2.19 1.378 1.378 0 0 0-.182.18l-.512.511a8.878 8.878 0 0 1-1.618-3.828h.728a1.413 1.413 0 0 0 1.411-1.427z"
          transform="translate(-2.077 -5.537)"
        />
        <path
          id="Path_210"
          data-name="Path 210"
          d="M166.439 589.69a11.851 11.851 0 0 0 1.206.062 11.756 11.756 0 0 0 11.729-11.762 11.781 11.781 0 0 0-2.641-7.422l-.058-.072h-.006a11.752 11.752 0 1 0-10.23 19.193zm8.9-16.175a8.847 8.847 0 0 1 1.085 3.065h-4.843zm-8.617 3.382a1.411 1.411 0 0 0 .889 2.5h8.807a8.965 8.965 0 0 1-8.8 7.518h-.014a8.93 8.93 0 0 1-.013-17.859h.015a8.9 8.9 0 0 1 5.95 2.272z"
          transform="translate(-2.077 -13.495)"
        />
        <path
          id="Path_211"
          data-name="Path 211"
          d="M193.219 553.194h32.846a1.413 1.413 0 0 0 1.412-1.411V531.71a1.413 1.413 0 0 0-1.412-1.411h-32.846a1.413 1.413 0 0 0-1.412 1.411v20.073a1.413 1.413 0 0 0 1.412 1.411zm31.435-18.543-5.644 4.01-5.575-1.635a1.417 1.417 0 0 0-1.412.4l-5.537 5.98-5.888-2.644a1.408 1.408 0 0 0-1.454.184l-4.514 3.565v-11.39h30.024zm-18.419 11.732a1.406 1.406 0 0 0 1.609-.331l5.635-6.052 5.4 1.578a1.409 1.409 0 0 0 1.214-.206l4.559-3.247v12.244h-30.023V548.1l5.588-4.412z"
          transform="translate(-10.033 -5.536)"
        />
        <path
          id="Path_212"
          data-name="Path 212"
          d="M195.453 581.719v4.681h-2.238a1.411 1.411 0 1 0 0 2.822h32.845a1.411 1.411 0 1 0 0-2.822h-2.238v-10.764a5.062 5.062 0 0 0-1.405-9.923h-.005a5.036 5.036 0 0 0-4.629 3.015l-3.178-.728a5.061 5.061 0 0 0-10.029.96 5.323 5.323 0 0 0 .118 1.064l-4.252 3.272a5.061 5.061 0 1 0-4.989 8.427zm-.828-4.857a2.238 2.238 0 1 1 2.238 2.238 2.241 2.241 0 0 1-2.238-2.237zm7.182-1.065 4.252-3.272a5.065 5.065 0 0 0 2.167 1.286V586.4h-9.951v-4.682a5.06 5.06 0 0 0 3.649-4.858 5.246 5.246 0 0 0-.116-1.06zm5.591-6.842a2.238 2.238 0 1 1 2.238 2.238 2.241 2.241 0 0 1-2.236-2.238zm3.65 17.445v-12.589a5.06 5.06 0 0 0 3.278-2.962l3.087.7a5.033 5.033 0 0 0 3.587 4.087V586.4zm9.124-15.621a2.238 2.238 0 1 1 2.238 2.238 2.241 2.241 0 0 1-2.237-2.237z"
          transform="translate(-10.029 -12.976)"
        />
      </g>
    </svg>
  )
}
export const Sensors = ({ color, w }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="60.137"
      // height="59.49"
      width={w}
      viewBox="0 0 60.137 59.49"
      fill={color}
    >
      <g
        id="Group_191"
        data-name="Group 191"
        transform="translate(-302.716 -519.6)"
      >
        <path
          id="Path_144"
          data-name="Path 144"
          d="M319.146 527.546A4.253 4.253 0 0 0 317 535.48v34.7h4.294v-34.7a4.253 4.253 0 0 0-2.147-7.934z"
          transform="translate(13.638 8.91)"
        />
        <path
          id="Path_145"
          data-name="Path 145"
          d="M314.591 525.29a12.734 12.734 0 0 0-.085 18.006l.085.085 3.057-3.031a8.466 8.466 0 0 1-.057-11.973l.057-.057z"
          transform="translate(9.088 6.381)"
        />
        <path
          id="Path_146"
          data-name="Path 146"
          d="m322.8 525.29-3.057 3.029a8.469 8.469 0 0 1 .057 11.975l-.057.055 3.057 3.031a12.732 12.732 0 0 0 .083-18.006z"
          transform="translate(19.092 6.381)"
        />
        <path
          id="Path_147"
          data-name="Path 147"
          d="m314.577 522.631-3.044-3.031a29.692 29.692 0 0 0-.24 41.99c.081.081.159.161.24.24l3.044-3.029a25.453 25.453 0 0 1-.176-36c.059-.055.116-.112.176-.17z"
        />
        <path
          id="Path_148"
          data-name="Path 148"
          d="m328.517 519.6-3.044 3.031a25.453 25.453 0 0 1 .174 36c-.057.057-.115.117-.174.174l3.044 3.029a29.694 29.694 0 0 0 .24-41.99z"
          transform="translate(25.519)"
        />
        <path
          id="Path_149"
          data-name="Path 149"
          d="m316.113 525.489-3.057-3.044a21.241 21.241 0 0 0-.125 30.036l.125.125 3.057-3.044a16.907 16.907 0 0 1-.163-23.91c.05-.052.108-.11.163-.163z"
          transform="translate(4.55 3.19)"
        />
        <path
          id="Path_150"
          data-name="Path 150"
          d="m325.661 522.445-3.057 3.044a16.907 16.907 0 0 1 .163 23.91l-.163.163 3.057 3.044a21.241 21.241 0 0 0 .125-30.036z"
          transform="translate(22.302 3.19)"
        />
      </g>
    </svg>
  )
}
